import { TitleOfferFragment, TitleOfferLightFragment } from '@/features/buybox/graphql/fragments/Offer.fragment';
import { ModalHelper } from '@/helpers/vfm/modal-helper';

import { type PlayerModalTitle } from '@/features/title-player/types';
import { WatchNowOfferFragment } from '@/pages/graphql/fragments/WatchNowOffer.fragment';
import { S72ModalContexts } from '@/features/jwtv-titles-rental/tracking';
import { JWTV_PROVIDER_CONFIG } from '@/features/jwtv/config';

const jwtvTitleRentalModal = () => import('@/features/jwtv-titles-rental/components/JwtvTitleRentalModal.vue');

type JWTVModalProps = (
	| {
			title: PlayerModalTitle;
			offer: TitleOfferFragment | WatchNowOfferFragment | TitleOfferLightFragment;
			overrideSuccessUrl?: string | null;
			promoCode?: string;
			titleSlug?: string;
			isFallback?: boolean;
	  }
	| {
			finalUrl: string;
	  }
) & {
	additionalContexts?: S72ModalContexts;
};

export async function openJwTvRentalModal(payload: { modalProps: JWTVModalProps; onClose?: () => void }) {
	await ModalHelper.openModal(
		jwtvTitleRentalModal,
		{
			...payload.modalProps,
		},
		{
			cssClass: 'account-modal',
			id: 'jwtv-rent-modal',
		},
		undefined,
		undefined,
		payload.modalProps.additionalContexts,
		() => {
			payload.onClose?.();
		}
	);
}

export function isJwtvTvodOffer(offer: TitleOfferFragment | WatchNowOfferFragment | TitleOfferLightFragment): boolean {
	const config = JWTV_PROVIDER_CONFIG.find(
		c => c.shortName === offer.package.shortName && c.monetizationTypes.includes(offer.monetizationType)
	);
	const isTvStreamUrl = !!offer.streamUrl?.includes('tv.justwatch.com');

	return (!!config && config.type === 'TVOD') || (offer.package.shortName === 'jwt' && isTvStreamUrl);
}
